module.exports = __webpack_public_path__ + "static/media/tonycreation2.fc8d9082.png";